const getters = {
  token: state => state.user.token,
  name: state => state.user.name
};
export default getters;
